import { render, staticRenderFns } from "./predictiveRiskComponent.vue?vue&type=template&id=46331568"
import script from "./predictiveRiskComponent.vue?vue&type=script&lang=js"
export * from "./predictiveRiskComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports